import { observable } from 'mobx';

import { SerializedData, Store } from 'bernie-core';

import { FlightsImagePlacard } from 'types/shared';

export class FreeCancellationStore extends Store {
  @observable public freeCancellation: FlightsImagePlacard;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}
